import {Input} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {Controller, DISABLE_AUTOCOMPLETE, useFormContext} from '@yandex-delivery/form'
import React from 'react'

import type {FlatInputProps} from './FlatInput.types'

export function FlatInput({name, 'data-testid': dataTestId}: FlatInputProps): React.ReactElement {
  const t = useI18n()
  const {control} = useFormContext()

  return (
    <Controller
      control={control}
      defaultValue=""
      name={name}
      render={({field, fieldState}) => (
        <Input
          autoCapitalize="none"
          autoComplete={DISABLE_AUTOCOMPLETE}
          data-testid={dataTestId}
          error={fieldState.invalid}
          helperText={fieldState.error?.message}
          label={t('cargo.create.address.sflat', 'Квартира')}
          name={name}
          onBlur={field.onBlur}
          onChange={field.onChange}
          size="l"
          spellCheck="false"
          value={field.value?.toString()}
          variant="line"
        />
      )}
    />
  )
}
